export default function loadClientSettings(settings) {
    settings["language"] = "en";
    settings["website"] = "api.uderly.it";
    settings["project-name"] = "Uderly";
    settings["api-url"] = "https://api.uderly.it/api/v1";
}
